<template>
  <validationObserver
    ref="customerDetailsForm"
    v-slot="{ handleSubmit }"
    slim
  >
    <b-card title="Update Customer Details Settings">
      <b-overlay
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-form
          ref="customerDetailsForm"
          @submit.prevent="handleSubmit(updateCustomerDetailsSetting)"
        >
          <b-row>
            <b-card title="Enable Customer Data Encryption">
              <b-form-radio-group
                v-model="customer_details_setting.customer_data_encryption_enabled"
                :options="encryptionOptions"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                :disabled="!canEditCustomerDetailsSetting"
                @change="updateCustomerDetailsSetting()"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              If this option is enabled, all customer data will be encrypted for enhanced security and
              privacy protection.
            </div>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card>
  </validationObserver>
</template>

<script>
import { ValidationObserver, extend } from 'vee-validate'
import { max, numeric } from 'vee-validate/dist/rules'
import {
  BRow, BForm, BCard, BOverlay, BFormRadioGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

extend('max', max)
extend('numeric', numeric)
const CustomerDetailsSettingRepository = RepositoryFactory.get('customerDetailsSetting')
export default {
  components: {
    BRow,
    BForm,
    BCard,
    BOverlay,
    BFormRadioGroup,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      customer_details_setting: {
        customer_data_encryption_enabled: false,
      },
      encryptionOptions: [
        { item: true, name: 'On' },
        { item: false, name: 'Off' },
      ],
    }
  },
  computed: {
    canEditCustomerDetailsSetting() {
      return this.$can('edit-security-setting')
    },
  },
  mounted() {
    this.readCustomerDetailsSetting()
  },
  methods: {
    async readCustomerDetailsSetting() {
      this.loading = true
      try {
        const data = localStorage.getItem('customer_details_setting') ? JSON.parse(localStorage.getItem('customer_details_setting')) : (await CustomerDetailsSettingRepository.getCustomerDetailsSetting()).data.data
        if (!localStorage.getItem('customer_details_setting')) localStorage.setItem('customer_details_setting', JSON.stringify(data))
        this.customer_details_setting = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async updateCustomerDetailsSetting() {
      try {
        const payload = {
          customer_data_encryption_enabled: this.customer_details_setting.customer_data_encryption_enabled,
        }
        const res = await CustomerDetailsSettingRepository.updateCustomerDetailsSetting(payload)
        if (res.status === 200) {
          localStorage.setItem('customer_details_setting', JSON.stringify(this.customer_details_setting))
          this.showSuccessMessage('Customer Details Settings Updated Successfully')
        } else {
          this.showErrorMessage('Cannot Update Customer Details Settings')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.set_right {
    float: right;
}

.custom-button-color {
    background-color: #4186f5 !important;
    border-color: #4186f5 !important;
}
</style>
